import { render, staticRenderFns } from "./SignupFormSimple.vue?vue&type=template&id=4515b12c&scoped=true&"
import script from "./SignupFormSimple.vue?vue&type=script&lang=js&"
export * from "./SignupFormSimple.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormSimple.vue?vue&type=style&index=0&id=4515b12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515b12c",
  null
  
)

export default component.exports